import { useQuery } from '@apollo/client';
import { GET_CALL_ACTIONS } from '../graphql/queries';

export interface CallActions {
  actionName: string;
  actionType: string;
  numCalls: number;
  percentCalls: number;
}

interface UseCallActionsProps {
  startDate: Date;
  endDate: Date;
  agentId?: string;
  minDurationSecs?: number;
  maxDurationSecs?: number;
  callDirection?: 'incoming' | 'outgoing';
}

export const useCallActions = ({
  startDate,
  endDate,
  agentId,
  minDurationSecs,
  maxDurationSecs,
  callDirection = 'incoming',
}: UseCallActionsProps) => {
  const { loading, error, data } = useQuery(GET_CALL_ACTIONS, {
    variables: {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      ...(agentId && { agentId }),
      minDurationSecs,
      maxDurationSecs,
      callDirection,
    },
  });

  return {
    loading,
    error,
    data: data?.getCallActions as CallActions[] | undefined,
  };
};
